<template>
  <div>
    <div class="loader" v-if="zoneProfileInstances === null">
      <v-progress-circular
          :size="70"
          :width="7"
          indeterminate
          color="primary"
      ></v-progress-circular>
    </div>
  <draggable
      class="list-group"
      tag="div"
      v-model="zoneProfileInstances"
      v-bind="dragOptions"
      @start="drag = true"
      @end="drag = false"
      handle=".zone-handle"
      group="zone_2"
      @change="onDrag"
  >
    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
      <template v-for="zoneProfileInstance in zoneProfileInstances">
        <Zone :key="zoneProfileInstance.id" :zoneProfileInstance="zoneProfileInstance"></Zone>
      </template>
    </transition-group>
  </draggable>
  </div>
</template>
<style scoped lang="scss">
  .loader {
    background-color: white;
    min-height: rem(300);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
<script>
import draggable from 'vuedraggable'
import Zone from './Zone'
import axios from 'axios'
import PositionsAPI from '@/api/positions'

export default {
  name: 'AdminZone',
  components: {
    draggable,
    Zone,
  },
  props: [
    'zoneNotice',
  ],
  data () {
    return {
      drag: false,
      zoneProfileInstances: null,
    }
  },
  mounted () {
    this.getZoneProfileInstances()
  },
  methods: {
    getZoneProfileInstances () {
      axios
          .get('/api/v2/zone_profile_instances', {
            params: {
              'profileInstance': this.$store.state.config.profile_instance_id,
              'zoneNotice': this.zoneNotice
            }
          })
          .then(response => {
            this.zoneProfileInstances = response.data['hydra:member']
          })
    },
    onDrag() {
      let positions = []
      this.zoneProfileInstances.forEach((zoneProfileInstance, index) => {
        positions.push({
          id: zoneProfileInstance.id,
          position: index + 1
        })
      })

      PositionsAPI.updates('zone-profile-instances', positions)
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  }
}
</script>
